<template>
    <table class="lanetable">
        <thead>
            <th v-for="(l, i) in lanes" :key="i" @drop="ondrop($event, l)">
                <div draggable="true" @dragover.prevent @drop="ondrop($event, l)">                
                <b-button-toolbar key-nav aria-label="Toolbar with button groups">
                    <b-button-group class="mx-1">
                        <b-button size="sm" variant="light" title="Töm banan" @click="clearLane(l)">
                            <!-- <b-icon-x-circle-fill></b-icon-x-circle-fill> -->
                            <i class="fa-regular fa-circle-xmark"></i>
                        </b-button>
                        <!-- <b-button size="sm" variant="light" @click="toggleExpandAll" title="Expandera alla">
                            <i class="fa-solid fa-angles-down"></i>
                        </b-button> -->
                    </b-button-group>
                    <b-button size="sm" variant="light">{{ l.name }}</b-button>
                </b-button-toolbar>
                </div>
            </th>
        </thead>
        <tbody>
            <td v-for="(l, i) in lanes" :key="i" @dragover.prevent @drop="ondropToLane($event, l)" draggable="true">
                <!-- {{ l.name }} -->

                <div v-for="(r, ridx) in l.routes" :key="ridx" draggable="true" @dragstart="dragStart($event, r, l)"
                    @dragover.prevent
                    :class="{currroute:r==selectedRoute}"
                    >
                    <!-- {{ ridx }} {{ r.name }} -->
                    <routedetailsVue :route="r" :cmds="cmds" :selectedStops="selectedStops"
                        @geocoded="onGeoCoded($event,r)" 
                        @autogeocode="onAutoGeoCode($event)"
                        @setdrag="onsetdrag($event)"
                        @setselect="onsetselect($event,r)"
                        @mapcommand="onmapcommand($event)"
                        @drop="ondropToRoute($event)"
                        @cmd="onCmd($event)"
                        @isolateaction="isolateAction($event,r)"
                        >                 
                    </routedetailsVue>
                </div>
            </td>

        </tbody>
    </table>
</template>
<script>
import routedetailsVue from './routedetails.vue';


export default {
    name: 'planpad',
    props: { lanes: Array,cmds:Array, selectedStops:Array, selectedRoute:Object },
    components: { routedetailsVue },    
    data() {
        return {

        }
    },
    methods: {
        clearLane(l) {
            l.routes = [];
        },
        ondropToLane(ev, l) {
            console.log('Dropped on lane');
            //alert('drop');
            var ctx = {type:'lane',lane:l};
            this.$emit('drop', ctx)
        },
        ondropToRoute(ev) {
            //Just pass
            this.$emit('drop', ev)
        },
        dragStart(ev, r, l) {
            this.$emit('setdrag', { type: 'route', route: r, lane: l })
        },
        onGeoCoded(ev,r) {
            //Finally, has changed geocodes for some of the bookings
            var evExt = {...ev, route: r};            
            this.$emit('geocoded', evExt);                                
        },
        onAutoGeoCode(ev) {
            this.$emit('autogeocode',ev);
        },
        onsetdrag(ev) {
            ev.route = this.route;
            this.$emit('setdrag', ev);
        },
        onsetselect(ev,r) {
            console.log('onsetselect')
            var extEv = {route: r, selected: ev};
            this.$emit('setselect', extEv);
        },
        onmapcommand(ev) {
            this.$emit('mapcommand',ev);
        },
        onCmd(ev) {
            this.$emit('cmd',ev);
        },
        isolateAction(ev,r) {
            this.$emit('isolateaction',ev);
        }
    }
}


</script>
<style scoped>
.lanetable {
    padding-top: 0px;
    padding-bottom: 0px;
    border-spacing: 1px;
    font-family: Verdana, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-size: smaller;
    table-layout: fixed;
}

td {
    vertical-align: top;
    text-align: left;
    border: 1px solid darkgray;
    width: 250px;
    height: 9999px
}

td:hover {
    background-color: darkgrey;
}
.currroute {
    border: 2px;
    border-color: red;
    background-color: red;
    padding:2px;
}
</style>
